module.exports = __webpack_public_path__ + "static/img/default_scene_Arch.73444fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/default_scene_Arch.jpg
// module id = 5tB9
// module chunks = 3